import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';

import Button from 'components/atoms/button';
import ArrowLink from 'components/atoms/arrowLink';
import FormContent from 'components/organisms/formContent';
import FormCol from 'components/molecules/formCol';
import FormActions from 'components/molecules/formActions';
import WizardProgress from 'components/organisms/wizard/progress';

import validate from '../validate';
import { currency } from 'helpers/format';
import * as planHelper from 'helpers/maintenancePlan';

class MaintenancePlans extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { handleSubmit, previousPage, vehicle, maintenancePlan } = this.props;

    return (
      <div className="serviceDetails">
        <Header inFlow />
        <WizardProgress step="2" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Contratos de mantenimiento</h2>

              <FormContent>
                <form onSubmit={handleSubmit}>
                  <FormCol single center>
                    <br />
                    <br />
                    <br />
                    {maintenancePlan.discount > 0 && (
                      <h3>Aprovecha un {maintenancePlan.discount}% de descuento</h3>
                    )}
                    {maintenancePlan.discount === 0 && <h3>Aprovecha un importante descuento</h3>}
                    <p className="b">
                      Nuestro contrato de mantenimiento para tu {vehicle.name} incluye: <br />{' '}
                      {maintenancePlan.services.length} servicios
                      {maintenancePlan.discount &&
                        ` con un ${maintenancePlan.discount}% de descuento`}
                      {maintenancePlan.installments &&
                        ` en hasta ${maintenancePlan.installments} cuotas`}
                      {maintenancePlan.online_pay_discount &&
                        ` y un beneficio de ${maintenancePlan.online_pay_discount}% de descuento por pago online.`}
                      {'.'}
                    </p>

                    <table className="serviceList">
                      <tbody>
                        {maintenancePlan.services.map(service => (
                          <tr key={service.id}>
                            <td>{service.name}</td>
                            <td>{currency(service.price)}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="2">
                            Precio normal:{' '}
                            <strong>{currency(planHelper.getRegularPrice(maintenancePlan))}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            Precio contrato de mantenimiento:{' '}
                            <strong>{currency(planHelper.getPrice(maintenancePlan))}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <h4>
                      Total a pagar online: {currency(planHelper.getPrice(maintenancePlan))}
                      {maintenancePlan.installments &&
                        ` en hasta ${maintenancePlan.installments} cuotas`}
                      {'.'}
                    </h4>
                    <br />
                    <p>
                      <Field
                        name="maintenance_plan_id"
                        component={ArrowLink}
                        props={{
                          fieldValue: 0,

                          buttonText: 'Si, quiero el contrato de mantenimiento',
                          onClick: () => {
                            handleSubmit();
                          },
                        }}
                      >
                        No, gracias. Continuar con mi turno.
                      </Field>
                    </p>
                    <br />
                    <br />
                    <br />
                  </FormCol>

                  <FormActions back={previousPage}>
                    <Field
                      name="maintenance_plan_id"
                      component={Button}
                      props={{
                        fieldValue: maintenancePlan.id,
                        buttonText: 'Si, quiero el contrato',
                        onClick: () => {
                          handleSubmit();
                        },
                      }}
                    />
                  </FormActions>
                </form>
              </FormContent>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

MaintenancePlans = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(MaintenancePlans);

const selector = formValueSelector('shiftRequest');

const mapStateToProps = state => {
  return {
    maintenancePlan: state.maintenancePlans.available,
    vehicle: selector(state, 'vehicle'),
    legacyService: selector(state, 'legacy_service'),
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenancePlans);
